"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToBlacklistUrl = void 0;

var goToBlacklistUrl = function goToBlacklistUrl() {
  // Kenny G
  // document.location.href = "https://www.youtube.com/watch?v=bYOE4XnrNeo&feature=youtu.be&t=90";
  // Rickroll
  document.location.href = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";
};

exports.goToBlacklistUrl = goToBlacklistUrl;